import { useEffect } from 'react';

const ICLOSED_URL = 'https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin';

export default function TestimonialsLP() {
  useEffect(() => {
    const id = 'rephub-script-lp';
    if (!document.getElementById(id)) {
      const script = document.createElement('script');
      script.id = id;
      script.type = 'text/javascript';
      script.src = 'https://reputationhub.site/reputation/assets/review-widget.js';
      document.body.appendChild(script);
    }
    return () => {
      const s = document.getElementById(id);
      if (s) document.body.removeChild(s);
    };
  }, []);

  return (
    <section
      className="w-full py-14 md:py-20 px-8 md:px-16"
      style={{ background: '#111111' }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="flex flex-col gap-4 mb-10">
          <p
            className="text-xs font-bold tracking-[0.25em] uppercase"
            style={{ color: 'rgba(200,146,42,0.8)' }}
          >
            Ce qu&apos;ils en disent
          </p>
          <h2
            className="text-4xl md:text-5xl font-black text-white leading-tight"
            style={{ letterSpacing: '-0.03em', fontFamily: '\'Inter\', sans-serif' }}
          >
            Ils ont arrêté de
            <br />
            <em
              className="not-italic"
              style={{
                color: '#C8922A',
                fontStyle: 'italic',
                fontFamily: '\'Georgia\', serif',
              }}
            >
              chasser à vue.
            </em>
          </h2>
          <p
            className="text-base max-w-xl leading-relaxed"
            style={{ color: 'rgba(255,255,255,0.5)' }}
          >
            PME, consultants, indépendants — voici ce qu&apos;ils ont obtenu avec un
            système de génération de leads qui tourne sans eux.
          </p>
        </div>

        {/* Widget */}
        <div
          className="rounded-sm overflow-hidden"
          style={{ background: '#1a1a1a' }}
        >
          <iframe
            className="lc_reviews_widget"
            src="https://reputationhub.site/reputation/widgets/review_widget/COnx2ltix5Ue2wCthqYv"
            frameBorder="0"
            scrolling="no"
            style={{ minWidth: '100%', width: '100%' }}
            title="Avis clients Usine à Leads"
          />
        </div>

        {/* CTA below reviews */}
        <div className="flex flex-col items-center gap-4 mt-12">
          <button
            data-iclosed-link={ICLOSED_URL}
            data-embed-type="popup"
            className="inline-flex items-center justify-center px-10 py-5 font-bold text-base transition-all duration-200 hover:brightness-110 active:scale-95 whitespace-nowrap cursor-pointer border-none"
            style={{
              background: '#C8922A',
              color: '#111111',
              borderRadius: '4px',
              letterSpacing: '-0.01em',
            }}
          >
            Accéder au diagnostic — 45 min offertes →
          </button>
          <p className="text-xs" style={{ color: 'rgba(255,255,255,0.3)' }}>
            Sans engagement · Résultats concrets ou on vous le dit clairement
          </p>
        </div>
      </div>
    </section>
  );
}
